import { CreatedByUser } from '../../types/apps/apps.types';
import { FeatureName } from '../Feature/feature';
import { ModuleNameEnum } from '../Module/module';
import { apps } from '../rolesAndPermission';

export const reportsModule = {
  reports: {
    id: 70,
    moduleName: ModuleNameEnum.REPORTS,
  },
} as const;
export const reportsModuleList = Object.entries(reportsModule).map(([key, v]) => ({
  key,
  createdBy: CreatedByUser.SYSTEM,
  ...v,
}));
export const reportsFeatures = {
  reports: {
    id: 199,
    featureName: FeatureName.REPORTS,
  },
} as const;
export const reportsFeaturesList = Object.entries(reportsFeatures).map(([key, v]) => ({
  key,
  ...v,
  createdBy: CreatedByUser.SYSTEM,
}));

export const reportAppModule = [{ appId: apps.dashboard.id, moduleId: reportsModule['reports'].id }];

export const reportsModuleFeatures = [
  { moduleId: reportsModule['reports'].id, featureId: reportsFeatures['reports'].id },
];

// add new features in the  sales_summary,net_sales, timecards, payroll_history

export const reportNewFeatures = {
  'sales-summary': { id: 211, featureName: FeatureName.SALES_SUMMARY },
  'net-sales': { id: 212, featureName: FeatureName.NET_SALES },
  timecards: { id: 213, featureName: FeatureName.TIMECARDS },
  'payroll-history': { id: 214, featureName: FeatureName.PAYROLL_HISTORY },
} as const;

// Separate object for the latest new features (IDs 223-231)
export const reportLatestNewFeatures = {
  'labor-cost': { id: 223, featureName: FeatureName.LABOR_REPORT },
  overtime: { id: 224, featureName: FeatureName.OVERTIME_REPORT },
  'employee-productivity': { id: 225, featureName: FeatureName.EMPLOYEE_PRODUCTIVITY_REPORT },
  'tip-pooling-report': { id: 226, featureName: FeatureName.TIP_POOLING_REPORT },
  'break-compliance': { id: 227, featureName: FeatureName.BREAK_COMPLIANCE_REPORT },
  'menu-summary': { id: 228, featureName: FeatureName.MENU_SUMMARY_REPORT },
  // Temporarily hidden - Marketing Reports (2026)
  // 'gift-card-report': { id: 229, featureName: FeatureName.GIFT_CARD_REPORT },
  // 'loyalty-report': { id: 230, featureName: FeatureName.LOYALTY_REPORT },
  // 'deals-report': { id: 231, featureName: FeatureName.DEALS_REPORT },
} as const;

// Deals Report - separate object (ID 231) to avoid disturbing old migrations that reference reportLatestNewFeaturesList
export const dealsReportFeature = {
  'deals-report': { id: 231, featureName: FeatureName.DEALS_REPORT },
} as const;

// Gift Card Report - separate object (ID 229) to avoid affecting old migrations
export const giftCardReportFeature = {
  'gift-card-report': { id: 229, featureName: FeatureName.GIFT_CARD_REPORT },
} as const;

// Separate object for payroll summary report (ID 233) - kept separate to avoid affecting old migrations
export const payrollSummaryReportFeature = {
  'payroll-summary-report': { id: 233, featureName: FeatureName.PAYROLL_SUMMARY },
} as const;

export const reportNewFeaturesList = Object.entries(reportNewFeatures).map(([key, v]) => ({
  key,
  ...v,
  createdBy: CreatedByUser.SYSTEM,
}));

export const reportNewModuleFeaturesNewList = [
  { moduleId: reportsModule['reports'].id, featureId: reportNewFeatures['sales-summary'].id },
  { moduleId: reportsModule['reports'].id, featureId: reportNewFeatures['net-sales'].id },
  { moduleId: reportsModule['reports'].id, featureId: reportNewFeatures['timecards'].id },
  { moduleId: reportsModule['reports'].id, featureId: reportNewFeatures['payroll-history'].id },
];

// Separate list for the latest new features (IDs 223-231)
export const reportLatestNewFeaturesList = Object.entries(reportLatestNewFeatures).map(([key, v]) => ({
  key,
  ...v,
  createdBy: CreatedByUser.SYSTEM,
}));

export const reportLatestNewModuleFeaturesList = [
  { moduleId: reportsModule['reports'].id, featureId: reportLatestNewFeatures['labor-cost'].id },
  { moduleId: reportsModule['reports'].id, featureId: reportLatestNewFeatures['overtime'].id },
  { moduleId: reportsModule['reports'].id, featureId: reportLatestNewFeatures['employee-productivity'].id },
  { moduleId: reportsModule['reports'].id, featureId: reportLatestNewFeatures['tip-pooling-report'].id },
  { moduleId: reportsModule['reports'].id, featureId: reportLatestNewFeatures['break-compliance'].id },
  { moduleId: reportsModule['reports'].id, featureId: reportLatestNewFeatures['menu-summary'].id },
  // Temporarily hidden - Marketing Reports (2026)
  // { moduleId: reportsModule['reports'].id, featureId: reportLatestNewFeatures['gift-card-report'].id },
  // { moduleId: reportsModule['reports'].id, featureId: reportLatestNewFeatures['loyalty-report'].id },
  // { moduleId: reportsModule['reports'].id, featureId: reportLatestNewFeatures['deals-report'].id },
];

// Separate list for payroll summary report (ID 233) - kept separate to avoid affecting old migrations
export const payrollSummaryReportFeaturesList = Object.entries(payrollSummaryReportFeature).map(([key, v]) => ({
  key,
  ...v,
  createdBy: CreatedByUser.SYSTEM,
}));

export const payrollSummaryReportModuleFeaturesList = [
  { moduleId: reportsModule['reports'].id, featureId: payrollSummaryReportFeature['payroll-summary-report'].id },
];

// Performance Summary Report feature
export const performanceSummaryReportFeature = {
  'performance-summary-report': { id: 236, featureName: FeatureName.PERFORMANCE_SUMMARY },
} as const;

export const performanceSummaryReportFeatureList = Object.entries(performanceSummaryReportFeature).map(([key, v]) => ({
  key,
  ...v,
  createdBy: CreatedByUser.SYSTEM,
}));

// Separate object for refund report (ID 237) - kept separate to avoid affecting old migrations
export const refundReportFeature = {
  'refund-report': { id: 237, featureName: FeatureName.REFUND_REPORT },
} as const;

export const refundReportFeatureList = Object.entries(refundReportFeature).map(([key, v]) => ({
  key,
  ...v,
  createdBy: CreatedByUser.SYSTEM,
}));

export const performanceSummaryReportModuleFeaturesList = [
  {
    moduleId: reportsModule['reports'].id,
    featureId: performanceSummaryReportFeature['performance-summary-report'].id,
  },
];

// Merchant Report feature (ID 240) - kept separate to avoid affecting old migrations
export const merchantReportFeature = {
  'merchant-report': { id: 240, featureName: FeatureName.MERCHANT_REPORT },
} as const;

export const merchantReportFeatureList = Object.entries(merchantReportFeature).map(([key, v]) => ({
  key,
  ...v,
  createdBy: CreatedByUser.SYSTEM,
}));

export const merchantReportModuleFeaturesList = [
  { moduleId: reportsModule['reports'].id, featureId: merchantReportFeature['merchant-report'].id },
];

export const thirdPartyReportFeature = {
  'third-party-order-report': { id: 238, featureName: FeatureName.THIRD_PARTY_ORDER_REPORT },
} as const;

export const thirdPartyReportFeatureList = Object.entries(thirdPartyReportFeature).map(([key, v]) => ({
  key,
  ...v,
  createdBy: CreatedByUser.SYSTEM,
}));

export const thirdPartyReportModuleFeaturesList = [
  {
    moduleId: reportsModule['reports'].id,
    featureId: thirdPartyReportFeature['third-party-order-report'].id,
  },
];
export const refundReportModuleFeaturesList = [
  {
    moduleId: reportsModule['reports'].id,
    featureId: refundReportFeature['refund-report'].id,
  },
];

export const dealsReportFeatureList = Object.entries(dealsReportFeature).map(([key, v]) => ({
  key,
  ...v,
  createdBy: CreatedByUser.SYSTEM,
}));

// Separate object for discount report (ID 241) - kept separate to avoid affecting old migrations
export const discountReportFeature = {
  'discount-report': { id: 241, featureName: FeatureName.DISCOUNT_REPORT },
} as const;

export const discountReportFeatureList = Object.entries(discountReportFeature).map(([key, v]) => ({
  key,
  ...v,
  createdBy: CreatedByUser.SYSTEM,
}));

export const dealsReportModuleFeaturesList = [
  {
    moduleId: reportsModule['reports'].id,
    featureId: dealsReportFeature['deals-report'].id,
  },
];

export const giftCardReportFeatureList = Object.entries(giftCardReportFeature).map(([key, v]) => ({
  key,
  ...v,
  createdBy: CreatedByUser.SYSTEM,
}));

export const giftCardReportModuleFeaturesList = [
  {
    moduleId: reportsModule['reports'].id,
    featureId: giftCardReportFeature['gift-card-report'].id,
  },
];

export const discountReportModuleFeaturesList = [
  {
    moduleId: reportsModule['reports'].id,
    featureId: discountReportFeature['discount-report'].id,
  },
];
